import { render, staticRenderFns } from "./access_control_face_roster.vue?vue&type=template&id=4077ba3c&scoped=true"
import script from "./access_control_face_roster.vue?vue&type=script&lang=js"
export * from "./access_control_face_roster.vue?vue&type=script&lang=js"
import style0 from "./access_control_face_roster.vue?vue&type=style&index=0&id=4077ba3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_babel-core@7.0.0-bridge.0_@babel+core@7.29._9691e8a1bbcd57691b862420a6e71e49/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4077ba3c",
  null
  
)

export default component.exports